import React from 'react';
import { formatDate, getTime } from '../../../utils/TimeUtils';
import { FormattedMessage } from 'react-intl';
import Row from '../../tag/Row';
import DayView from './DayView';
import Span from '../../tag/Span';

// eslint-disable-next-line no-undef
const { id: module_id } = module;

const getWeek = (startDate) => {
  const days = [];
  for (let i = 0; i < 5; i++) {
    days.push(startDate.clone().add(i, 'days'));
  }
  return days;
};

/**
 * Find days to be rendered from given data
 * @param days
 * @param data
 * @returns {*}
 */
const findDays = (days, data) => {
  return days.map((day) => {
    return {
      day: day,
      availableTimes: data[formatDate(day)],
    };
  });
};

const resolveStartOfWeek = (data) => {
  const earliestTime = Object.keys(data)
    .map((x) => {
      return data[x];
    })
    .sort((a, b) => (a.day.isBefore(b.day) ? -1 : 1))
    .map((x) => {
      return x;
    })[0];
  return earliestTime.day.startOf('week');
};

class Calendar extends React.Component {
  constructor() {
    super();
    this.state = {
      startOfWeek: null,
    };
  }

  componentDidMount() {
    if (this.props.data) {
      this.initStartOfWeek(this.props.data);
    }
  }

  componentDidUpdate(oldProps) {
    if (oldProps.data && !this.props.data) {
      this.initStartOfWeek(oldProps.data);
    }
  }

  initStartOfWeek = (data) => {
    this.setState({
      startOfWeek: resolveStartOfWeek(data),
    });
  };

  selectWeek = (forward) => {
    this.setState({
      startOfWeek: this.state.startOfWeek
        .clone()
        [forward ? 'add' : 'subtract'](1, 'week'), // eslint-disable-line no-unexpected-multiline
    });
  };

  render() {
    const { data, selectedTime, selectTime } = this.props;
    const { startOfWeek } = this.state;

    const days = startOfWeek ? getWeek(startOfWeek) : null;
    if (!days) {
      return null;
    }
    const currentDay = getTime();
    const renderDays = findDays(days, data);

    return (
      <>
        {/*show week number*/}
        <div className={'weeknumber'}>
          <FormattedMessage
            id={`${module_id}.week.number`}
            values={{ week: startOfWeek.week() }}
          />
        </div>
        <Row>
          <Span len="6" sm-len="6">
            <button
              className={'selectweek left '}
              onClick={() => this.selectWeek(false)}
            >
              <span className={'selectweek-wrapper left'}>
                <FormattedMessage id={`${module_id}.show.previous.week`} />
              </span>
            </button>
          </Span>
          <Span len="6" sm-len="6">
            <button
              className={'selectweek right'}
              onClick={() => this.selectWeek(true)}
            >
              <span className={'selectweek-wrapper right'}>
                <FormattedMessage id={`${module_id}.show.next.week`} />
              </span>
            </button>
          </Span>
        </Row>
        <Row style={{ minHeight: '500px' }}>
          {renderDays.map((day) => (
            <div key={formatDate(day.day)} className={'dayview-column'}>
              <DayView
                data={day}
                selectTime={selectTime}
                selectedTime={selectedTime}
                currentDay={currentDay}
              />
            </div>
          ))}
        </Row>
      </>
    );
  }
}

export default Calendar;
